export default {
  SIZE: 'data-size',
  STATUS: 'data-status',
  PREFIX: 'data-prefix',
  DISABLED: 'data-disabled',
  HOVER: 'data-hover',
  FOCUS: 'data-focus',
  LEFTBORDERRADIUS: 'data-left-border-radius',
  RIGHTBORDERRADIUS: 'data-right-border-radius',
};
